import styled from "styled-components";

export const HeroBanner = styled.div`
  position: relative;
  top: 0;
  left: 0;
  padding: 71px 0px;
  text-align: center;
  background-color: #fbfaf6;
  margin-bottom: 581px;
`;

export const HeroBannerTitle = styled.p`
  margin: 0;
  color: #125f3f;
  font-weight: 500;
  font-size: 22px;
  line-height: 24px;
  letter-spacing: -0.44px;
  @media (min-width: 1028px) {
    font-weight: 500;
    font-size: 24px;
    line-height: 48px;
    letter-spacing: normal;
  }
`;

export const HeroBannerHeader = styled.p`
  color: #0a0f1c;
  padding: 9px 13px;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: -0.3px;
  & > span {
    font-size: 14px;
  }
  @media (min-width: 472px) {
    padding: 9px 60px;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.4px;
    & > span {
      font-size: 20px;
    }
  }
  @media (min-width: 930px) {
    margin: 0;
    padding: 9px 114px;
    font-size: 60px;
    line-height: 80px;
    letter-spacing: -0.8px;
    & > span {
      font-size: 40px;
    }
  }
`;



export const BannerImageContainer = styled.div`
  padding-top: 46px;
  & > * {
    overflow: visible !important;
  }
  & > * > img {
    margin-top: 85px !important;
  }
  @media (min-width: 472px) {
    padding-top: 93px;
  }
  @media (min-width: 930px) {
    padding-top: 27px;
  }
`;

export const LargeDropShadow = styled.div`
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  max-width: 1440px;
  width: 100%;
  min-height: 494px;
  top: 1220px;
  background: #1c2547;
  opacity: 0.1;
  filter: blur(200px);
  @media (max-width: 1078px) {
    display: none;
  }
`;

export const SmallDropShadow = styled.div`
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  max-width: 1440px;
  width: 100%;
  min-height: 97px;
  top: 1800px;
  background: #1c2547;
  opacity: 0.1;
  filter: blur(200px);
  @media (max-width: 1078px) {
    display: none;
  }
`;

export const SectionHeadingContainer = styled.div`
  margin-bottom: ${(props) => (props.mb ? props.mb : "0")};
  margin-top: ${(props) => (props.mt ? props.mt : "0")};
  padding-top: ${(props) => (props.pt ? props.pt : "0")};
  text-align: center;
  & > p:first-child {
    font-weight: 500;
    font-size: 24px;
    line-height: 48px;
    letter-spacing: -0.8px;
    color: ${(props) => (props.invert ? "white" : "#125f3f")};
  }
  & > p:last-child {
    font-size: 26px;
    line-height: 34px;
    letter-spacing: -0.8px;
    color: ${(props) => (props.invert ? "white" : "black")};
    @media (min-width: 472px) {
      font-size: 34px;
      line-height: 42px;
    }
    @media (min-width: 930px) {
      font-size: 44px;
      line-height: 52px;
    }
  }
`;

export const FeaturesTableText = styled.p`
  color: ${(props) => (props.green ? "#125F3F" : "#273240")};
  font-size: 16px;
  line-height: 24px;
  font-weight: ${(props) => (props.green ? "500" : "400")};
  margin-bottom: 9px;
`;

export const FeaturesTableDivider = styled.hr`
  border-top: 1px solid ${(props) => (props.grey ? "#CBD4DB" : "#273240")};
  margin-bottom: ${(props) => (props.mb ? "13px" : "0")};
  margin-top: ${(props) => (props.mt ? "23px" : "0")};
`;

export const OurFocusGrid = styled.div`
  display: grid;
  gap: 30px;
  margin: 0 auto;
  margin-bottom: 240px;
  grid-template-columns: repeat(1, 1fr);
  gap: 30px;
  padding-bottom: 88px;
  @media (min-width: 1242px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const OurFocusGridItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  color: white;
  & > p:nth-of-type(1) {
    font-size: 28px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.7px;
    margin: 25px 0 15px 0;
  }
  & > p:nth-of-type(2) {
    font-size: 16px;
    line-height: 26px;
    padding-bottom: 40px;
  }
`;

export const UserCarouselTestimonial = styled.p`
  max-width: 583px;
  font-size: 20px;
  line-height: 27px;
  font-weight: 500;
  margin: 30px 0 13px 0;
  color: white;
  @media (min-width: 420px) {
    font-size: 22px;
    line-height: 29px;
  }
  @media (min-width: 480px) {
    font-size: 24px;
    line-height: 31px;
  }
  @media (min-width: 768px) {
    font-size: 26px;
    line-height: 33px;
  }
  @media (min-width: 960px) {
    font-size: 28px;
    line-height: 35px;
  }
`;

export const Rand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > div {
    display: flex;
    align-items: center;
  }
`;

export const CTAButton = styled.button`
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    outline: none;
    transition: all .1s ease-out;
    box-shadow: none;
    background-color: ${props => props.color == 'black' ? '#1a1a1a' : props.color == 'white' ? '#fff' : '#e32900'};
    color: ${props => props.color == 'white' ? '#1a1a1a' : 'white'};
    font-size: 18px;
    padding: 4px 30px;
    height: auto;
    line-height: 1.5;
    margin: 12px 0;
    min-height: 54px;
    transition: background-color 0.3s ease;


    &:hover {
        background-color: ${props => props.color == 'white' ? '#fafafa' : props.color == 'red' ? '#d61c00' : '#1a1a1a' };
    }

    @media (min-width: 768px) {
        margin: 0 16px
    }

`